import { GeoZonesStyle, GeoZoneType, InfoZoneType, SimpleZoneType } from "../../../../geo-zones/models/geo-zones.models";

export interface SimpleZoneStyle extends GeoZonesStyle {
    borderWidth: number;
}

// TODO: UX-215 - use colors from pallet when added
export const GEO_ZONE_STYLES: { [key in GeoZoneType]?: GeoZonesStyle } & { Default: GeoZonesStyle } = {
    [GeoZoneType.DroneAirspaceProhibited]: {
        borderColor: "#ce0000",
        fillColor: "#ff3318",
        fillOpacity: 0.5,
    },
    [GeoZoneType.DroneAirspaceRestricted]: {
        borderColor: "#ffa000", // $legacy-color-primary-700
        fillColor: "#ffca28", // $legacy-color-primary-400
        fillOpacity: 0.5,
    },
    [GeoZoneType.DroneAirspaceRestrictedHigh6Km]: {
        borderColor: "#1067c3", // $legacy-color-secondary-800
        fillColor: "#3fa6fd",
        fillOpacity: 0.2,
    },
    [GeoZoneType.DroneAirspaceRestrictedHigh]: {
        borderColor: "#007544", // $legacy-color-status-success
        fillColor: "#17a766",
        fillOpacity: 0.2,
    },
    [GeoZoneType.DroneAirspaceRestrictedMedium]: {
        borderColor: "#e65000",
        fillColor: "#f57c00",
        fillOpacity: 0.25,
    },
    [GeoZoneType.DroneAirspaceRestrictedLow]: {
        borderColor: "#720015",
        fillColor: "#8f0c23",
        fillOpacity: 0.3,
    },
    [GeoZoneType.DroneTrafficManagement]: {
        borderColor: "#015b2a",
        fillColor: "#015b2a",
        fillOpacity: 0.1,
    },
    [GeoZoneType.DroneAirspaceInformation]: {
        borderColor: "#8d99b1", // $legacy-color-gray-200
        fillColor: "#d9d9d9",
        fillOpacity: 0.01,
    },
    [GeoZoneType.DrarProhibted]: {
        borderColor: "#ce0000",
        fillColor: "#ff3318",
        fillOpacity: 0.5,
    },
    Default: {
        borderColor: "#8d99b1", // $legacy-color-gray-200
        fillColor: "#fff", // $legacy-color-white
        fillOpacity: 0.01,
    },
};

export const SIMPLE_ZONE_STYLES: { [key in SimpleZoneType]?: SimpleZoneStyle } & { Default: SimpleZoneStyle } = {
    Default: {
        borderColor: "#8d99b1", // $legacy-color-gray-200
        fillColor: "#fff", // $legacy-color-white
        fillOpacity: 0.01,
        borderWidth: 2,
    },
    [SimpleZoneType.DronePoint]: {
        borderColor: "#637292", // $legacy-color-gray-300
        fillColor: "#637292", // $legacy-color-gray-300
        fillOpacity: 0.3,
        borderWidth: 4,
    },
};

export const CUSTOM_OPACITY_SETTINGS_FOR_TYPE: Record<number, string[]> = {
    0.01: ["CTR6KM", "CTR1KM", "CTR"],
    0.1: ["TMA", "ATZ", "MCTR"],
    0.2: ["ATZ6KM"],
    0.3: ["ATZ1KM", "MCTR2KM", "MCTR1KM"],
};

const MAIN_ICON_COLOR = "#223d6b"; // $legacy-color-gray-500
const ACCENT_ICON_COLOR = "#8d99b1"; // $legacy-color-gray-200
const WARNING_ICON_COLOR = "#cc3f12"; // $legacy-color-status-warning-text
const WHITE_ICON_COLOR = "#ffffff"; // $legacy-color-white

export interface LocalInfoIcon {
    code: string;
    color: string;
}

export interface LocalInfoIconSettings {
    icon: LocalInfoIcon[];
    background?: {
        color: string;
        padding?: number;
    };
}

// NOTE: code values are taken from the IconFont.css file
export const LOCAL_INFO_ICON_SETTINGS: { [key in InfoZoneType | SimpleZoneType]: LocalInfoIconSettings } = {
    [InfoZoneType.Landings]: {
        icon: [
            {
                code: "eb12", // hems-emr
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.PermanentGathering]: {
        icon: [
            {
                code: "eb1a", // team-fill-complex-1b
                color: MAIN_ICON_COLOR,
            },
            {
                code: "eb1b", // team-fill-complex-1a
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.TemporaryGathering]: {
        icon: [
            {
                code: "eb1a", // team-fill-complex-1b
                color: MAIN_ICON_COLOR,
            },
            {
                code: "eb1b", // team-fill-complex-1a
                color: ACCENT_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.Obstacles]: {
        icon: [
            {
                code: "eb15", // barricade-fill
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.AdsbReceivers]: {
        icon: [
            {
                code: "ead9", // base-station-fill
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.AdsbCoverMap]: {
        icon: [
            {
                code: "eb13", // signal-tower-fill
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [InfoZoneType.OtherInformation]: {
        icon: [
            {
                code: "eb16", // stack-fill
                color: MAIN_ICON_COLOR,
            },
        ],
    },
    [SimpleZoneType.DronePoint]: {
        icon: [
            {
                code: "eba7", // dronepoint
                color: WHITE_ICON_COLOR,
            },
        ],
        background: {
            color: WARNING_ICON_COLOR,
            padding: 4,
        },
    },
};
